import employeePriceContainer from './employee-price';

/**
 * @param {Object} priceInfo - price info
 * @returns {string} product price HTML
 */
export default priceInfo => {
    if (!priceInfo) {
        return ``;
    }

    const isEmployee = User.isEmployee && User.employeeDiscountLevel && priceInfo.employeePrices && priceInfo.minPrice;

    let employeePrice;
    let salePriceFormatted;
    let fromPrice = priceInfo.promotionalPrice ? priceInfo.promotionalPrice : priceInfo.minPrice;

    if (isEmployee) {
        const priceData = JSON.parse(priceInfo.employeePrices);
        employeePrice = priceData[User.employeeDiscountLevel];
        fromPrice = employeePrice;
    }

    if (priceInfo.salePriceValue && priceInfo.salePriceValue < priceInfo.priceValue) {
        salePriceFormatted = priceInfo.salePrice;
    }
    if (priceInfo.promotionalPrice && priceInfo.promotionalPriceValue < priceInfo.salePriceValue) {
        salePriceFormatted = priceInfo.promotionalPrice;
    }

    return `
        ${`
        <div class="product-pricing">
                <span class="component price">
                    ${
                        !priceInfo.noprice
                            ? `
                                ${
                                    priceInfo.showFrom
                                        ? `
                                        <span class="price-from">
                                            ${window.Resources.PRODUCT_PRICE_FROM_LABEL}
                                        </span>
                                        <span class="price-standard">
                                            ${fromPrice}
                                        </span>
                                        `
                                        : `
                                        ${
                                            isEmployee
                                                ? employeePriceContainer(employeePrice, priceInfo.minPrice)
                                                : `
                                                ${
                                                    salePriceFormatted
                                                        ? `
                                                            <span class="price-promotion">
                                                                ${salePriceFormatted}
                                                            </span>                                                            
                                                            <span class="price-strike">
                                                                ${priceInfo.minPrice}
                                                            </span>`
                                                        : `
                                                        <span class="price-standard">
                                                            ${priceInfo.minPrice}
                                                        </span>`
                                                }`
                                        }`
                                }
                                ${
                                    priceInfo.additionalInfo && !priceInfo.isCosmetics
                                        ? `
                                        <span class="price-additional-info">
                                            ${priceInfo.additionalInfo}
                                        </span>
                                        `
                                        : ''
                                }
                            `
                            : ''
                    }
                </span>
            </div>`}
    `;
};
